import React, {useCallback, useState} from 'react'
import {useIntl} from 'react-intl'

import {AttendanceReportExportPayload} from '../../../modes/attendance/attendanceReportExportTypes'
import {downloadAttendanceReportSpreadsheet} from '../../../modes/attendance/exportAttendanceRecordsCsv'
import {downloadAttendanceReportPdf} from '../../../modes/attendance/exportAttendanceReportPdf'

type AttendanceReportExportButtonsProps = {
  exportPayload: AttendanceReportExportPayload | null
  theme: 'light' | 'dark'
  inline?: boolean
}

const AttendanceReportExportButtons: React.FC<AttendanceReportExportButtonsProps> = ({
  exportPayload,
  inline = false,
}) => {
  const intl = useIntl()
  const [pdfLoading, setPdfLoading] = useState(false)

  const handleDownloadExcel = useCallback(() => {
    if (!exportPayload) return
    downloadAttendanceReportSpreadsheet(exportPayload)
  }, [exportPayload])

  const handleDownloadPdf = useCallback(async () => {
    if (!exportPayload || pdfLoading) return
    try {
      setPdfLoading(true)
      await downloadAttendanceReportPdf(exportPayload)
    } finally {
      setPdfLoading(false)
    }
  }, [exportPayload, pdfLoading])

  if (!exportPayload) return null

  return (
    <div className={`d-flex gap-1 ${inline ? 'flex-nowrap' : 'flex-wrap ms-auto'}`}>
      <button
        type='button'
        className='btn btn-sm btn-light-success d-inline-flex align-items-center justify-content-center'
        onClick={handleDownloadExcel}
        style={{
          width: 34,
          height: 30,
          padding: 0,
          flexShrink: 0,
        }}
        aria-label={intl.formatMessage({id: 'CHATBOT.ATTENDANCE.DOWNLOAD_EXCEL'})}
        title={intl.formatMessage({id: 'CHATBOT.ATTENDANCE.DOWNLOAD_EXCEL'})}
      >
        <i
          className='fa fa-file-excel'
          aria-hidden
          style={{fontSize: 14, padding: 0, margin: 0, lineHeight: 1}}
        />
      </button>
      <button
        type='button'
        className='btn btn-sm btn-light-danger d-inline-flex align-items-center justify-content-center'
        onClick={() => void handleDownloadPdf()}
        disabled={pdfLoading}
        style={{
          width: 34,
          height: 30,
          padding: 0,
          flexShrink: 0,
        }}
        aria-label={intl.formatMessage({id: 'CHATBOT.ATTENDANCE.DOWNLOAD_PDF'})}
        title={intl.formatMessage({id: 'CHATBOT.ATTENDANCE.DOWNLOAD_PDF'})}
      >
        <i
          className='fa fa-file-pdf'
          aria-hidden
          style={{fontSize: 14, padding: 0, margin: 0, lineHeight: 1}}
        />
      </button>
    </div>
  )
}

export default AttendanceReportExportButtons
